export const initial = {
    fieldToEdit: '',
    title: "Form title",
    description: "Form description",
    type: "object",
    required: [],
    properties: {},
    uiSchema: {},
}

export const template1 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d21262a6-f941-49a6-9717-087bebbb570e": {
            "id": "d21262a6-f941-49a6-9717-087bebbb570e",
            "title": "Subject",
            "type": "string",
            "isRequired": false,
            "rows": 1,
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        },
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "id": "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297",
            "title": "Message",
            "type": "string",
            "isRequired": false,
            "rows": "4",
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        }
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
}
export const template2 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d21262a6-f941-49a6-9717-087bebbb570e": {
            "id": "d21262a6-f941-49a6-9717-087bebbb570e",
            "title": "Subject",
            "type": "string",
            "isRequired": false,
            "rows": 1,
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        },
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
}

export const template3 = {
    "fieldToEdit": "",
    "title": "Form title",
    "description": "Form description",
    "type": "object",
    "required": [],
    "properties": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "id": "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297",
            "title": "Message",
            "type": "string",
            "isRequired": false,
            "rows": "4",
            "enumType": "dropdown",
            "minimum": 0,
            "maximum": 0,
            "default": ""
        }
    },
    "uiSchema": {
        "d2bbd209-c896-4bf8-9a8d-ec2c88b9a297": {
            "ui:widget": "textarea",
            "ui:options": {
                "rows": 4
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/widget/components/Steps/FormCreator/Templates.js